var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0738 13.3909H27.9998V13.3356H15.9998V18.6689H23.5352C22.4358 21.7736 19.4818 24.0023 15.9998 24.0023C11.5818 24.0023 7.99984 20.4203 7.99984 16.0023C7.99984 11.5843 11.5818 8.00228 15.9998 8.00228C18.0392 8.00228 19.8945 8.77161 21.3072 10.0283L25.0785 6.25695C22.6972 4.03761 19.5118 2.66895 15.9998 2.66895C8.6365 2.66895 2.6665 8.63895 2.6665 16.0023C2.6665 23.3656 8.6365 29.3356 15.9998 29.3356C23.3632 29.3356 29.3332 23.3656 29.3332 16.0023C29.3332 15.1083 29.2412 14.2356 29.0738 13.3909Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2041 9.79628L8.58477 13.0089C9.7701 10.0743 12.6408 8.00228 16.0001 8.00228C18.0394 8.00228 19.8948 8.77161 21.3074 10.0283L25.0788 6.25695C22.6974 4.03761 19.5121 2.66895 16.0001 2.66895C10.8788 2.66895 6.43743 5.56028 4.2041 9.79628Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 29.3357C19.4439 29.3357 22.5732 28.0177 24.9392 25.8744L20.8125 22.3824C19.4739 23.3964 17.8099 24.0024 15.9999 24.0024C12.5319 24.0024 9.58722 21.7911 8.47788 18.7051L4.12988 22.0551C6.33655 26.3731 10.8179 29.3357 15.9999 29.3357Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.074 13.3903H28V13.335H16V18.6683H23.5353C23.0073 20.1596 22.048 21.4456 20.8107 22.3823L20.8127 22.381L24.9393 25.873C24.6473 26.1383 29.3333 22.6683 29.3333 16.0016C29.3333 15.1076 29.2413 14.235 29.074 13.3903Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleReview);
export default __webpack_public_path__ + "static/media/google-review.c8bc64c8404218bb38f7675fbe19c40b.svg";
export { ForwardRef as ReactComponent };